import React, { useEffect } from 'react'
import { useState } from 'react'
import ModalFilter from '../ModalFilter'
import Voice2Text from '../../Voice2Text'
import BtnGlemoImg from '../../../assets/btn-voice-glemo.webp'
import { LAST_3_SEARCHED } from '../../../constants/storageNames'
import Voice2TextBusca from '../../Voice2TextBusca'
import ModalSearching from '../ModalSearching'

interface Props {
  showModal: boolean
  closeModal: () => void
  valInput: (input: string) => void
}

export function ModalBuscaVoz({ showModal, closeModal, valInput }: Props) {
  const [showModalFilter, setShowModalFilter] = useState(false)
  const [searching, setSearching] = useState(false)
  const [valueInput, setValueInput] = useState('')
  const [historicoBuscas, setHistoricoBuscas] = useState<string[]>(
    JSON.parse(localStorage.getItem(LAST_3_SEARCHED) ?? '[]')
  )

  const handleChangeTranscript = (transcript: string) => {
    let val = transcript.trim()
    if(val.includes('/4')){
      val = val.replace('/4', ' quartos')
    }
    setValueInput(val.trim())
  }

  useEffect(() => {
    if (valueInput) {
      if (!historicoBuscas.includes(valueInput))
        setHistoricoBuscas([valueInput, ...historicoBuscas].slice(0, 3))
      localStorage.setItem(LAST_3_SEARCHED, JSON.stringify(historicoBuscas))
      setTimeout(() => {
        setSearching(true)
      }, 3000)
      setTimeout(() => {
        valInput(valueInput)
      }, 5000)
    }
  }, [valueInput])

  return (
    <>
      {showModal ? (
        <>
          {searching ? (
            <ModalSearching />
          ) : (
            <>
              <div className="modal-form-busca modal-form-busca-mobile justify-center fixed z-[1001] w-[100vw] h-[100vh] top-0 left-0">
                <div className="relative w-full h-full justify-items-center lg:py-5">
                  <div className="container-modal justify-between lg:px-8 lg:pt-8 lg:rounded-md pb-10 h-full border-0 text-black max-w-[441px] relative flex flex-col bg-white outline-none focus:outline-none p-4 overflow-y-auto w-full">
                    <>
                      <div>
                        <div className="flex justify-between">
                          {/* back icon */}
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            className="cursor-pointer"
                            onClick={closeModal}
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2689 7.69777H4.32678L10.2714 1.75312L8.76134 0.253662L0.253784 8.76122L8.76134 17.2688L10.2608 15.7693L4.32678 9.82466H17.2689V7.69777Z"
                              fill="#F15C00"
                            />
                          </svg>

                          {/* clean icon */}
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            className="cursor-pointer"
                            onClick={() => setValueInput('')}
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.6828 1.81659L14.1833 0.317139L8.23866 6.26179L2.29401 0.317139L0.794556 1.81659L6.73921 7.76125L0.794556 13.7059L2.29401 15.2054L8.23866 9.2607L14.1833 15.2054L15.6828 13.7059L9.73812 7.76125L15.6828 1.81659Z"
                              fill="#F15C00"
                            />
                          </svg>
                        </div>
                        <div
                          className="grid content-between grid-modal-busca-voz"
                        >
                          <div className="py-5">
                            <hr className="opacity-20" />
                            <div className="py-3">
                              <h5 className="italic text-start text-base text-gray-500">
                                Últimas buscas
                              </h5>
                              {historicoBuscas && (
                                <>
                                  {historicoBuscas
                                    .filter((x) => x)
                                    .map((item) => {
                                      return (
                                        <div className="flex mt-5">
                                          <svg
                                            width="22"
                                            height="23"
                                            className="inline-block -mt-[3px] me-3"
                                            viewBox="0 0 22 23"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g clipPath="url(#clip0_9975_7045)">
                                              <path
                                                d="M14.7013 13.6343C15.6275 12.3208 16.1663 10.721 16.1663 8.98651C16.1663 4.52391 12.5457 0.90332 8.08316 0.90332C3.62056 0.90332 -3.05176e-05 4.52391 -3.05176e-05 8.98651C-3.05176e-05 13.4491 3.62056 17.0697 8.08316 17.0697C9.85135 17.0697 11.468 16.4971 12.7983 15.5541L19.0123 21.768C19.5343 22.2901 20.3932 22.2901 20.9152 21.768C21.4373 21.246 21.4373 20.3872 20.9152 19.8651L14.7013 13.6343ZM8.08316 14.9815C4.78252 14.9815 2.08813 12.304 2.08813 8.98651C2.08813 5.68587 4.76568 2.99148 8.08316 2.99148C11.4006 2.99148 14.0782 5.68587 14.0782 8.98651C14.0782 12.304 11.4006 14.9815 8.08316 14.9815Z"
                                                fill="#4D4D4D"
                                                fill-opacity="0.6"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_9975_7045">
                                                <rect
                                                  width="21.3362"
                                                  height="21.2689"
                                                  fill="white"
                                                  transform="translate(-3.05176e-05 0.90332)"
                                                />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <h5 className="text-sm mb-0">{item}</h5>
                                        </div>
                                      )
                                    })}
                                </>
                              )}
                            </div>
                            <hr className="opacity-20" />
                            <h3 className="text-lg mt-4 text-start">{valueInput}</h3>
                          </div>
                          <div className="text-center justify-items-center">
                            <Voice2Text
                              changeTranscript={(transcript: string) =>
                                handleChangeTranscript(transcript)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-[1000] bg-black"></div>
            </>
          )}
        </>
      ) : null}
      <>
        <ModalFilter show={showModalFilter} blackBg close={() => setShowModalFilter(false)} />
      </>
    </>
  )
}
